/**
 * Created by work on 17/3/21.
 */
// import { TI_JIAN_LIST, REFRESH_LIST } from '../actions/life';
//
// const initState = {
//   tiJianListData: [],
//   refreshListData: []
// };
//
// export default (state = initState, action) => {
//   switch (action.type) {
//     case TI_JIAN_LIST: {
//       return Object.assign({}, state, {tiJianListData: action.tiJianListData});
//     }
//     case REFRESH_LIST: {
//       return Object.assign({}, state, state.tiJianListData.map((item) => {
//         return state.refreshListData.map((ite) => {
//           return (
//             () => {
//               if (item.id === ite.id) {
//                 return Object.assign({}, item, ite);
//               }
//               return null;
//             }
//           );
//         });
//       }));
//     }
//     default:
//       return state;
//   }
// };
import {REFRESH_LIFE_SUBTAB, REFRESH_LIFE_TAB, REPORT_TOKEN} from '../actions/life';

const initState = {
  subTab: true,
  tab: 0,
  reportToken: ''
};

export default (state = initState, action) => {
  switch (action.type) {
    case REFRESH_LIFE_SUBTAB: {
      return Object.assign({}, state, {subTab: action.newSubTab});
    }
    case REFRESH_LIFE_TAB: {
      return Object.assign({}, state, {tab: action.newTab});
    }
    case REPORT_TOKEN: {
      return Object.assign({}, state, {reportToken: action.newReportToken});
    }
    default:
      return state;
  }
};


// WEBPACK FOOTER //
// ./src/reducers/life.js